var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-row',[_c('b-col',[_c('b-tabs',[_c('b-tab',{attrs:{"title":_vm.$t('views.excmcase.list.searchParams.filterCaseByCustomField')}},[_c('caseCustomFields')],1),_c('b-tab',{attrs:{"title":_vm.$t('views.excmcase.list.searchParams.filterTaskByCustomField')}},[_c('taskCustomFields')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }